import { createStyles } from '@affstore-ds/uikit'

export const useAuthWrapperStyles = createStyles((theme) => ({
  formWrapper: {
    alignItems: 'center',
    backgroundColor: theme.other.colors.white[0],
    borderRadius: theme.other.borderRadius[8],
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
  },
}))
